import { render, staticRenderFns } from "./DeviceOta.vue?vue&type=template&id=2bc3272a&scoped=true"
import script from "./DeviceOta.vue?vue&type=script&lang=js"
export * from "./DeviceOta.vue?vue&type=script&lang=js"
import style0 from "./DeviceOta.vue?vue&type=style&index=0&id=2bc3272a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3272a",
  null
  
)

export default component.exports